import { render, staticRenderFns } from "./DevLayoutIcons.vue?vue&type=template&id=8292f24e&scoped=true&lang=pug&"
import script from "./DevLayoutIcons.vue?vue&type=script&lang=ts&"
export * from "./DevLayoutIcons.vue?vue&type=script&lang=ts&"
import style0 from "./DevLayoutIcons.vue?vue&type=style&index=0&id=8292f24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8292f24e",
  null
  
)

export default component.exports